import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./fabricante-listar/fabricante-listar.module').then(m => m.FabricanteListarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./fabricante-inserir/fabricante-inserir.module').then(m => m.FabricanteInserirModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./fabricante-editar/fabricante-editar.module').then(m => m.FabricanteEditarModule) }
    ])],
    exports: [RouterModule]
})
export class FabricanteAppRoutingModule { }